export default __webpack_public_path__ + "static/media/dont-smoke.2cf31e96.png";